import useCurrentUser from './useCurrentUser'

const useUserProgram = () => {
  const { data: currentUser } = useCurrentUser()
  return currentUser?.userProfile?.program
}

export default useUserProgram
